module.exports = __webpack_public_path__ + "img/3x.53f66c2.jpg";